// @flow
/**
 * AspectFaces selectors
 **/
import { createSelector } from "reselect";
import { Map } from "immutable";

const getGlobalsStore = (state: Map<string, any>) => {
  return state.get("globals");
};

const getWorldFinalsYear = createSelector(
  getGlobalsStore,
  (globals: Map<string, any>) => {
    return globals.get("worldFinalsYear");
  }
);

const getRegionalsYear = createSelector(
  getGlobalsStore,
  (globals: Map<string, any>) => {
    return globals.get("regionalsYear");
  }
);

const getWorldFinalsContestId = createSelector(
  getGlobalsStore,
  (globals: Map<string, any>) => {
    return globals.get("worldFinalsContestId");
  }
);

const getSelectedYear = createSelector(
  getGlobalsStore,
  (globals: Map<string, any>) => {
    return globals.get("selectedYear");
  }
);

const getYear = createSelector(
  getRegionalsYear,
  getWorldFinalsYear,
  (regYear: number, wfYear: number) => {
    return wfYear;
  }
);

const getCurrentContestId = createSelector(
  getGlobalsStore,
  (globals: Map<string, any>) => {
    return globals.get("currentContestId");
  }
);

const getCurrentContestName = createSelector(
  getGlobalsStore,
  (globals: Map<string, any>) => {
    return globals.get("currentContestName");
  }
);

const isLoading = createSelector(
  getGlobalsStore,
  (globals: Map<string, any>) => {
    return globals.get("loading");
  }
);

const isError = createSelector(getGlobalsStore, (globals: Map<string, any>) => {
  return globals.get("error");
});

export {
  getWorldFinalsYear,
  getRegionalsYear,
  getWorldFinalsContestId,
  getSelectedYear,
  getCurrentContestId,
  getCurrentContestName,
  getYear,
  isLoading,
  isError,
};
